if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.free_gift_id = this.dataset.freeGiftId;
        console.log(this.free_gift_id);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.cart.setActiveElement(document.activeElement);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        let formData;
        let disableNotification = true;
        const id = this.form.getAttribute('id');
        const addedEngraving = document.querySelector(`.engraving-modal--engraving-added[data-form="${id}"]`);
        const bundleProduct = this.form.querySelector('[name="bundle_product"]');
        // console.log('addedEngraving', addedEngraving);
        if (addedEngraving) {
          formData = this.buildEngravingForm(addedEngraving);
        } else if (bundleProduct) {
          formData = this.buildBundleForm(bundleProduct);
        } else {
          formData = this.buildProductForm();
          disableNotification = false;
        }

        formData = this.addUpsells(formData);
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;

        config.body = JSON.stringify(formData);
        // return console.log(formData);
        let cartJson = await fetch(`${window.routes.cart_url}.js`).then((res) => res.json());
        const giftItemInCart = cartJson.items.filter((i) => {
          console.log(i.variant_id);
          return i.variant_id == this.free_gift_id;
        });
        console.log(giftItemInCart);
        if (giftItemInCart.length > 0) {
          this.free_gift_id = '';
        }
        if (this.free_gift_id != '') {
          let free_gift_formData = {
            id: `${this.free_gift_id}`,
            quantity: 1,
            properties: {
              _gift_product: true,
            },
          };
          fetch(`${routes.cart_add_url}.js`, {
            body: JSON.stringify(free_gift_formData),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then((res) => res.json())
            .then((data) => {
              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  // return console.log(response);
                  if (response.status) {
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }

                  if (!response.key && this.cart.tagName == 'CART-NOTIFICATION')
                    window.location = window.routes.cart_url;

                  this.error = false;
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove('loading');
                  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
            });
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              // return console.log(response);
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!response.key && this.cart.tagName == 'CART-NOTIFICATION') window.location = window.routes.cart_url;

              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      buildEngravingForm(addedEngraving) {
        const bottleId = this.form.querySelector('[name="id"]').value;
        const quantityEl = document.querySelector(`[form="${this.form.getAttribute('id')}"][name="quantity"]`);
        const bottleQuanity = quantityEl ? quantityEl.value : 1;
        const engravingVarId = addedEngraving.dataset.engravingVariantId;
        const engravingChars = addedEngraving.querySelector('[name="engraving"]').value.toUpperCase();
        const engravingId = Date.now().toString().slice(9);

        let formItems = [];

        const bottleItems = {
          id: bottleId,
          quantity: bottleQuanity,
          properties: {
            Engraving: engravingChars,
            _bundle: engravingId,
          },
        };

        formItems.unshift(bottleItems);

        const engravingItem = {
          id: engravingVarId,
          quantity: bottleQuanity,
          properties: {
            Engraving: engravingChars,
            For: this.form.querySelector('[name="id"]').dataset.productTitle,
            _bundle: engravingId,
          },
        };
        // add items o the begging so it show in the cart in the same order as on the mixmatch widget
        formItems.unshift(engravingItem);

        var formData = {
          items: formItems,
        };

        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        return formData;
      }

      buildBundleForm(bundleProduct) {
        const bottleId = this.form.querySelector('[name="id"]').value;
        const quantityEl = document.querySelector(`[form="${this.form.getAttribute('id')}"][name="quantity"]`);
        const bottleQuanity = quantityEl ? quantityEl.value : 1;
        const bundleVarId = bundleProduct.value;
        const bundleId = Date.now().toString().slice(9);

        let bundleQuanity = bundleProduct.dataset.limitToOne == 'true' ? 1 : bottleQuanity;

        let formItems = [];

        const bottleItems = {
          id: bottleId,
          quantity: bottleQuanity,
          properties: {
            _bundle: bundleId,
          },
        };

        formItems.unshift(bottleItems);

        const engravingItem = {
          id: bundleVarId,
          quantity: bundleQuanity,
          properties: {
            _bundle: bundleId,
            For: this.form.querySelector('[name="id"]').dataset.productTitle,
          },
        };
        // add items o the begging so it show in the cart in the same order as on the mixmatch widget
        formItems.unshift(engravingItem);

        var formData = {
          items: formItems,
        };

        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        return formData;
      }
      buildProductForm() {
        const formData = {
          items: [
            {
              id: this.form.querySelector('[name="id"]').value,
              quantity: this.form.querySelector('[name="quantity"]')?.value || 1,
              properties: {
                ...Array.from(this.form.querySelectorAll('[name="properties[]"]').entries()).reduce(
                  (acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                  },
                  {}
                ),
              },
            },
          ],
        };
        return formData;
      }

      addUpsells(formData) {
        const upsellProducts = this.closest('.product').querySelectorAll('.popular-add-ons__checkbox-input:checked');
        upsellProducts.forEach((upsellProduct) => {
          formData.items.push({
            id: upsellProduct.dataset.variantId,
            quantity: 1,
            properties: {
              _type: 'upsell',
            },
          });
        });
        return formData;
      }
    }
  );
}
